document.addEventListener("DOMContentLoaded", function () {
	initAOSClasses();
	AOS.init();
	ps_initThemeToggle();
	handleStickyHeaderOnScroll();
	psWrapButtonText();
})
//Initialize Accordion
if (document.querySelector(".accordion-container")) {
	new Accordion(".accordion-container");
}

if (document.querySelector(".ps-carousel-one")) {
	if (document.querySelector(".glide__slides")) {
		var allSlides = document.querySelectorAll(".glide");
		var allSlidesArray = Array.prototype.slice.call(allSlides);
		allSlidesArray.forEach((slide) => {
			const glide = new Glide(slide, {
				type: "carousel",
				perView: 4, // Display 4 slides per view
				perTouch: 1,
				focusAt: 0, // Focus on the first slide
				autoplay: false,
				accessibility: true,
				startAt: 0,
				rewind: true,
				draggable: true,
				swipeThreshold: 80,
				dragThreshold: 120,
				classes: {
					disabledArrow: "glide__arrow--disabled",
				},
				peek: {
					before: 0, // No peek before, showing the full leftmost slide
					after: 150, // Showing half of the rightmost slide
				},
				breakpoints: {
					800: {
						perView: 3.5, // Adjust for smaller screens if necessary
						draggable: true,
						perTouch: 1,
						startAt: 0,
						peek: 0,
						swipeThreshold: 10,
						dragThreshold: 20,
					},
					peek: {
						before: 0, // No peek before, showing the full leftmost slide
						after: 150, // Showing half of the rightmost slide
					},

				},
			}).mount();
		});
	}
}

// version 2 carousel
if (document.querySelector(".ps-carousel-two")) {
	var allSlides = document.querySelectorAll(".glide");
	var allSlidesArray = Array.prototype.slice.call(allSlides);
	allSlidesArray.forEach((slide) => {
		const glide = new Glide(slide, {
			type: "carousel",
			perView: 4, // Display 4 slides per view by default
			perTouch: 1,
			focusAt: 0, // Focus on the first slide
			autoplay: false,
			accessibility: true,
			startAt: 0,
			rewind: true,
			draggable: true,
			swipeThreshold: 80,
			dragThreshold: 120,
			classes: {
				disabledArrow: "glide__arrow--disabled",
			},
			peek: {
				before: 50, // No peek before, showing the full leftmost slide
				after: 150, // Showing half of the rightmost slide
			},
			breakpoints: {
				800: {
					perView: 3, // Show 3 slides per view on smaller screens (mobile)
					perTouch: 1,
					draggable: true,
					startAt: 0,
					peek: 0,
					swipeThreshold: 10,
					dragThreshold: 20,
					peek: {
						before: 100, // No peek before, showing the full leftmost slide
						after: 150, // Showing half of the rightmost slide
					},
				},
				// SMALL MOBILE 
				480: {
					perView: 1,
					perTouch: 1,
					rewind: false,  
					bound: true
				}
			}
		}).mount();
	});
}



//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
	allBtns.forEach((btn) => {
		if (btn.hasAttribute("href")) {
			let ctaLink = btn.getAttribute("href").split("/");

			if (ctaLink[2] !== currentHost) {
				btn.classList.add("external-link");
				btn.append(externalText);
			}
		}
	});
}
if (document.querySelector(".cta-btn")) {
	let currentHost = window.location.hostname;
	let ctaBtn = document.querySelector(".cta-btn");
	let ctaLink = ctaBtn.getAttribute("href").split("/");

	if (ctaLink[0] !== currentHost) {
		ctaBtn.classList.add("external-link");
		ctaBtn.append(externalText);
	}
}


////Pagination
if (document.querySelector(".navigation-pagination")) {
	let paginationList = document.querySelectorAll(".navigation-pagination ul li");

	if (paginationList[0].classList.contains("active")) {
		paginationList[0].style.position = "relative";
	}

	if (paginationList[paginationList.length - 1].classList.contains("active")) {
		paginationList[paginationList.length - 1].style.position = "relative";
	}
}

////Masonary
if (document.querySelector(".allcontainer")) {
	var elem = document.querySelector(".allcontainer");
	var msnry = new Masonry(elem, {
		// options
		itemSelector: ".item",
		columnWidth: ".grid-sizer",
		gutter: 15,
	});

	//Filters

	let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
	let selectedValue;
	let selectedOption;
	let availableItems;
	let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener("click", onClickChange);
	}

	//Click Filter
	function onClickChange() {
		selectedValue = this.value;

		allblocks.forEach(function (block) {
			block.classList.remove("block");

			if (selectedValue == "all") {
				block.classList.add("block");
			}

			if (block.getAttribute("data-cat") == selectedValue) {
				block.classList.add("block");
			}
		});
		msnry.layout();

		availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
		document.getElementById("select").addEventListener("change", onSelectChange);
	}

	availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

	document.getElementById("select").addEventListener("change", onSelectChange);

	function onSelectChange() {
		selectedOption = this.value;

		availableItems.forEach(function (item) {
			item.classList.remove("block");

			if (selectedOption == "all") {
				item.classList.add("block");
			}

			if (item.getAttribute("data-tag") == selectedOption) {
				item.classList.add("block");
			}
		});

		//Filter Click
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener("click", onClickChange);
		}

		msnry.layout();
	}

	/////Script_AJAX
	/* Ajax functions */
	$(document).ready(function () {
		//onclick
		$("#loadMore").on("click", function (e) {
			e.preventDefault();
			//init
			var that = $(this);
			var page = $(this).data("page");
			var newPage = page + 1;
			var ajaxurl = that.data("url");
			//ajax call
			$.ajax({
				url: ajaxurl,
				type: "post",
				data: {
					page: page,
					action: "ajax_script_load_more",
				},
				error: function (response) {
					console.log(response);
				},
				success: function (response) {
					//check
					if (response == 0) {
						$(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
						$("#loadMore").hide();
					} else {
						that.data("page", newPage);
						$("#ajax-primary").append(response);

						msnry = new Masonry(elem, {
							// options
							itemSelector: ".item",
							columnWidth: ".grid-sizer",
							gutter: 15,
						});

						msnry.layout();
					}
				},
			});
		});
	});
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
	document.querySelector(".content-area").style.marginTop = 0;
}

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
	var btnbgColor = $(this).css("backgroundColor");
	var btnColor = $(this).css("color");

	$(this)
		.mouseenter(function () {
			$(this).css({
				"background-color": btnColor,
				color: btnbgColor,
				"border-color": btnColor
			});
		})
		.mouseleave(function () {
			$(this).css({
				"background-color": btnbgColor,
				color: btnColor,
				"border-color": btnbgColor
			});
		});
});

// global classes for animations
function initAOSClasses() {
	let all_firstslide = document.querySelectorAll(".aos-fade-left-five-h");
	let all_secondslide = document.querySelectorAll(".aos-fade-left-eight-h");
	let all_thirdslide = document.querySelectorAll(".aos-fade-left-twelve-h");
	//  Fade left animation
	let aos_fade_left_animation = document.querySelectorAll(".aos-fade-left,.is-style-aos-fade-left");
	//  Fade right animation
	let aos_fade_right_animation = document.querySelectorAll(".aos-fade-right,.is-style-aos-fade-right");
	//  Fade right animation slow
	let aos_fade_right_slow_animation = document.querySelectorAll(".aos-fade-right-slow");
	//  Fade up animation
	let aos_fade_up_animation = document.querySelectorAll(".aos-fade-up,.is-style-aos-fade-up");
	//  Fade down animation
	let aos_fade_down_animation = document.querySelectorAll(".aos-fade-down");
	//  Zoom in animation
	let aos_zoom_in_animation = document.querySelectorAll(".aos-zoom-in,.is-style-aos-zoom-in");
	//  Zoom out animation
	let aos_zoom_out_animation = document.querySelectorAll(".aos-zoom-out");

	//  Flip left animation
	let aos_flip_left_animation = document.querySelectorAll(".aos-flip-left");
	//  Flip right animation
	let aos_flip_right_animation = document.querySelectorAll(".aos-flip-right");
	//  Flip up out animation
	let aos_flip_up_animation = document.querySelectorAll(".aos-flip-up");
	//  Flip down animation
	let aos_flip_down_animation = document.querySelectorAll(".aos-flip-down");
	//  Zoom in up animation
	let aos_zoom_in_up_animation = document.querySelectorAll(".aos-zoom-in-up,.is-style-aos-zoom-in-up");
	//  Zoom in down animation
	let aos_zoom_in_down_animation = document.querySelectorAll(".aos-zoom-in-down");
	//  Zoom in left animation
	let aos_zoom_in_left_animation = document.querySelectorAll(".aos-zoom-in-left");
	//  Zoom in right animation
	let aos_zoom_in_right_animation = document.querySelectorAll(".aos-zoom-in-right");

	if (all_firstslide) {
		for (let i = 0; i < all_firstslide.length; i++) {
			all_firstslide[i].setAttribute("data-aos", "fade-left");
			all_firstslide[i].setAttribute("data-aos-duration", "500");
			// all_firstslide[i].setAttribute("data-aos-offset","100");
		}
	}
	if (all_secondslide) {
		for (let i = 0; i < all_secondslide.length; i++) {
			all_secondslide[i].setAttribute("data-aos", "fade-left");
			all_secondslide[i].setAttribute("data-aos-duration", "800");
			// all_secondslide[i].setAttribute("data-aos-offset","400");
		}
	}
	if (all_thirdslide) {
		for (let i = 0; i < all_thirdslide.length; i++) {
			all_thirdslide[i].setAttribute("data-aos", "fade-left");
			all_thirdslide[i].setAttribute("data-aos-duration", "1200");
			// all_thirdslide[i].setAttribute("data-aos-offset","800");
		}
	}

	//  Fade left animation
	if (aos_fade_left_animation) {
		for (let i = 0; i < aos_fade_left_animation.length; i++) {
			aos_fade_left_animation[i].setAttribute("data-aos", "fade-left");
		}
	}
	//  Fade right animation
	if (aos_fade_right_animation) {
		for (let i = 0; i < aos_fade_right_animation.length; i++) {
			aos_fade_right_animation[i].setAttribute("data-aos", "fade-right");
		}
	}
	//  Fade right animation slow
	if (aos_fade_right_slow_animation) {
		for (let i = 0; i < aos_fade_right_slow_animation.length; i++) {
			aos_fade_right_slow_animation[i].setAttribute("data-aos", "fade-right");
			aos_fade_right_slow_animation[i].setAttribute(
				"data-aos-duration",
				"1200"
			);
		}
	}
	//  Fade up animation
	if (aos_fade_up_animation) {
		for (let i = 0; i < aos_fade_up_animation.length; i++) {
			aos_fade_up_animation[i].setAttribute("data-aos", "fade-up");
		}
	}
	//  Fade down animation
	if (aos_fade_down_animation) {
		for (let i = 0; i < aos_fade_down_animation.length; i++) {
			aos_fade_down_animation[i].setAttribute("data-aos", "fade-down");
		}
	}
	//  Zoom in animation
	if (aos_zoom_in_animation) {
		for (let i = 0; i < aos_zoom_in_animation.length; i++) {
			aos_zoom_in_animation[i].setAttribute("data-aos", "zoom-in");
		}
	}
	//  Zoom out animation
	if (aos_zoom_out_animation) {
		for (let i = 0; i < aos_zoom_out_animation.length; i++) {
			aos_zoom_out_animation[i].setAttribute("data-aos", "zoom-out");
		}
	}
	//  Flip left animation
	if (aos_flip_left_animation) {
		for (let i = 0; i < aos_flip_left_animation.length; i++) {
			aos_flip_left_animation[i].setAttribute("data-aos", "flip-left");
		}
	}
	//  Flip right animation
	if (aos_flip_right_animation) {
		for (let i = 0; i < aos_flip_right_animation.length; i++) {
			aos_flip_right_animation[i].setAttribute("data-aos", "flip-right");
		}
	}
	//  Flip up out animation
	if (aos_flip_up_animation) {
		for (let i = 0; i < aos_flip_up_animation.length; i++) {
			aos_flip_up_animation[i].setAttribute("data-aos", "flip-up");
		}
	}
	//  Flip down animation
	if (aos_flip_down_animation) {
		for (let i = 0; i < aos_flip_down_animation.length; i++) {
			aos_flip_down_animation[i].setAttribute("data-aos", "flip-down");
		}
	}
	//  Zoom in up animation
	if (aos_zoom_in_up_animation) {
		for (let i = 0; i < aos_zoom_in_up_animation.length; i++) {
			aos_zoom_in_up_animation[i].setAttribute("data-aos", "zoom-in-up");
		}
	}
	//  Zoom in down animation
	if (aos_zoom_in_down_animation) {
		for (let i = 0; i < aos_zoom_in_down_animation.length; i++) {
			aos_zoom_in_down_animation[i].setAttribute("data-aos", "zoom-in-down");
		}
	}
	//  Zoom in left animation
	if (aos_zoom_in_left_animation) {
		for (let i = 0; i < aos_zoom_in_left_animation.length; i++) {
			aos_zoom_in_left_animation[i].setAttribute("data-aos", "zoom-in-left");
		}
	}
	//  Zoom in right animation
	if (aos_zoom_in_right_animation) {
		for (let i = 0; i < aos_zoom_in_right_animation.length; i++) {
			aos_zoom_in_right_animation[i].setAttribute("data-aos", "zoom-in-right");
		}
	}
};

// JavaScript code for gradient change //
const buttons = document.querySelectorAll('.wp-block-button__link');

function hasGradientBackground(element) {
	const backgroundImage = window.getComputedStyle(element).backgroundImage;
	return backgroundImage.includes('gradient');
}

function reverseGradient(element) {
	const backgroundImage = window.getComputedStyle(element).backgroundImage;
	const reversedGradient = backgroundImage.replace(/linear-gradient\(([^,]+),/, (match, p1) => {
		let newDirection;
		if (p1.includes('deg')) {
			const angle = parseFloat(p1);
			newDirection = (angle + 180) % 360 + 'deg';
		} else {
			const directions = {
				'to top': 'to bottom',
				'to bottom': 'to top',
				'to left': 'to right',
				'to right': 'to left',
				'to top left': 'to bottom right',
				'to top right': 'to bottom left',
				'to bottom left': 'to top right',
				'to bottom right': 'to top left'
			};
			newDirection = directions[p1] || p1;
		}
		return `linear-gradient(${newDirection},`;
	});
	element.style.backgroundImage = reversedGradient;
}

buttons.forEach(button => {
	if (hasGradientBackground(button)) {
		const originalBackground = window.getComputedStyle(button).backgroundImage;

		button.addEventListener('mouseover', () => {
			reverseGradient(button);
		});

		button.addEventListener('mouseout', () => {
			button.style.backgroundImage = originalBackground;
		});
	}
});

function ps_initThemeToggle() {
	// Check if theme-toggle element exists
	const toggleSwitch = document.getElementById('theme-toggle');
	if (!toggleSwitch) {
		return; // Exit if the theme toggle doesn't exist
	}

	// Get the current theme from localStorage or set it to 'light' by default
	const currentTheme = localStorage.getItem('theme') || 'light';

	// Apply the stored theme (dark or light)
	if (currentTheme === 'dark') {
		document.body.classList.add('dark-mode');
	}

	// Toggle theme on button click
	toggleSwitch.addEventListener('click', function () {
		document.body.classList.toggle('dark-mode');
		let theme = document.body.classList.contains('dark-mode') ? 'dark' : 'light';
		localStorage.setItem('theme', theme); // Save the selected theme in localStorage
	});
}

// sticky header on scroll with animation
function handleStickyHeaderOnScroll() {
	if (screen.width > 960) {
		var previousScrollpos = window.scrollY; // Use scrollY instead of screenY

		window.addEventListener("scroll", (event) => {
			var currentScrollPos = window.scrollY;
			//console.log(currentScrollPos); // This can be removed after testing
			let site_header = document.querySelector(".site-header");
			let site_body = document.querySelector(".transparent_header");
			let ps_position = (site_body) ? 'absolute' : 'relative';

			// Handle scroll up (show header)
			if (previousScrollpos > currentScrollPos) {
				site_header.style.top = "0";
				if (currentScrollPos > 100) {
					site_header.classList.add("header-show");
					site_header.style.position = 'sticky';
				}
			} else { // Handle scroll down (hide header)
				site_header.style.top = "-100px";
				site_header.classList.remove("header-show");
				site_header.style.position = ps_position;
			}

			// Reset header position if at the top of the page
			if (currentScrollPos < 100) {
				site_header.style.position = ps_position;
				site_header.classList.remove("header-show");
			}

			// Update previous scroll position
			previousScrollpos = currentScrollPos;
		});
	}
}

function psWrapButtonText() {
	// Select all buttons with the custom style
	const buttons = document.querySelectorAll(
		".wp-block-button.is-style-button-with-bg-circle-arrow .wp-block-button__link"
	);

	buttons.forEach((btn) => {
		// Only wrap if no <span> exists inside
		if (!btn.querySelector("span")) {
			const text = btn.textContent.trim(); // Get text only
			if (text) {
				btn.textContent = ""; // Clear original text
				const span = document.createElement("span");
				span.textContent = text;
				btn.appendChild(span);
			}
		}
	});
}